import { Injectable } from '@angular/core';
import { AppService } from './app.service';
import { UtilVoicesService } from './util-voices.service';
import { MessageFreeVoicesReady, MessagePlusVoicesReady, MessageService, MessageUserUpdated } from './message.service';

export class PlusVoice {
  constructor(
    public speakerId: string,
    public isExpired: boolean,
    public isOwner: boolean,
    public weeklyInstallCount: number = 0,
    public createdTimestamp: number = 0,
    public sharing: string = 'none',
    public creatorEmail: string = '',
    public customSharedUsers: string[] = [],
    public tags: string[] = [],
    public gender: string = '',
    public description: string,
    public key: string,
    public name: string,
    public language: string,
    public languageName: string,
    public localeName: string,
    public displayLocale: boolean,
    public source: string,
    public id: string,
    public ready: string,
    public noAuth: boolean,
    public isLlm: boolean,
    public isLegacy: boolean,
    public isHot: boolean = false,
    public isNew: boolean = false,
    public icon: string = '',
    public type: string = 'plus'
  ) {
  }
}

@Injectable({
  providedIn: 'root'
})
export class SimplePlusVoicesService {
  public voices: Map<string, PlusVoice>;
  public clonedVoices: Map<string, PlusVoice>;
  public communityVoices: Map<string, any> = new Map();
  public communityLastKey = {};
  public hasAllCommunityVoices: boolean = false;
  public combinedVoices: Map<string, PlusVoice>;
  private isVoicesSet: boolean = false;
  public toSetClonedVoices: boolean = false;

  public popularLanguages: Array<string> = [
    'Multi-Lingual',
    'English (US)',
    'English (Canada)',
    'English (UK)',
    'English (Australia)',
    'German (Germany)',
    'Portuguese (Brazil)',
    'Korean (Korea)',
    'Japanese (Japan)',
    'Spanish (Spain)',
    'French (France)',
    'Italian (Italy)',
    'Hindi (India)',
    'Chinese (Mandarin)',
  ];

  constructor(
    public voiceUtilService: UtilVoicesService,
    private messageService: MessageService
  ) {
    if (AppService.isPW() || AppService.isAndroid() || AppService.isIOS()) {
      this.voices = new Map<string, PlusVoice>();
      this.clonedVoices = new Map<string, PlusVoice>();
      this.messageService.getMessage().subscribe(message => {
        if (message.name === MessageFreeVoicesReady) {
          this.setVoices().then(() => {
            setTimeout(() => {
              this.messageService.sendMessage({ name: MessagePlusVoicesReady });
            }, 1000);
          });
        }
      });
    }
  }

  public setVoices(): Promise<any> {
    return Promise.resolve()
      .then(() => {
        return Promise.resolve()
          .then(() => {
            if (this.isVoicesSet) {
              return Promise.resolve();
            }

            this.addVoice('Arnaud', 'nl-BE', 'ms', '124', '1');
            this.addVoice('Dena', 'nl-BE', 'ms', '125', '1');
            this.addVoice('Harri', 'fi-FI', 'ms', '134', '1');
            this.addVoice('Noora', 'fi-FI', 'ms', '135', '1');
            this.addVoice('Noemi', 'hu-HU', 'ms', '136', '1');
            this.addVoice('Tamas', 'hu-HU', 'ms', '137', '1');

            // HOT en-US LLM
            this.addVoice('Adam', 'en-US', 'ms', '235', '1', true, false, true, false, ["Deep", "Engaging"]);
            this.addVoice('Evelyn', 'en-US', 'ms', '211', '1', true, false, true, false, ["Soft", "Emotional"]);
            this.addVoice('Derek', 'en-US', 'ms', '209', '1', true, false, true, false, ["Formal", "Confident"]);
            this.addVoice('Lola', 'en-US', 'ms', '216', '1', true, false, true, false, ["Calm", "Warm"]);
            this.addVoice('Lewis', 'en-US', 'ms', '212', '1', true, false, true, false, ["Confident", "Authoritative"]);
            this.addVoice('Ava', 'en-US', 'ms', '186', '1', true, false, true, false, ["Bright", "Engaging"]);
            this.addVoice('Andrew', 'en-US', 'ms', '188', '1', true, false, true, false, ["Warm", "Engaging"]);
            this.addVoice('Cora', 'en-US', 'ms', '207', '1', true, false, true, false, ["Soft", "Melancholy"]);
            this.addVoice('Steffan', 'en-US', 'ms', '240', '1', true, false, true, false, ["Soft", "Calm"]);
            this.addVoice('Serena', 'en-US', 'ms', '215', '1', true, false, true, false, ["Mature", "Confident"]);

            // NEW en-US LLM
            this.addVoice('Dustin', 'en-US', 'ms', '210', '1', true, false, false, true, ["Unique", "Expressive"]);
            this.addVoice('Phoebe', 'en-US', 'ms', '213', '1', true, false, false, true, ["Youthful", "Upbeat"]);
            this.addVoice('Samuel', 'en-US', 'ms', '214', '1', true, false, false, true, ["Sincere", "Expressive"]);
            this.addVoice('Amanda', 'en-US', 'ms', '236', '1', true, false, false, true, ["Bright", "Youthful"]);
            this.addVoice('Christopher', 'en-US', 'ms', '208', '1', true, false, false, true, ["Warm", "Conversational"]);

            // existing en-US LLM
            this.addVoice('Davis', 'en-US', 'ms', '65', '1', true, false, false, false, ["Calm", "Conversational"]);
            this.addVoice('Nancy', 'en-US', 'ms', '67', '1', true, false, false, false, ["Professional", "Confident"]);
            this.addVoice('Brandon', 'en-US', 'ms', '237', '1', true, false, false, false, ["Soft", "Warm"]);
            this.addVoice('Emma', 'en-US', 'ms', '189', '1', true, false, false, false, ["Friendly", "Sincere"]);
            this.addVoice('Nova', 'en-US', 'ms', '233', '1', true, false, false, false, ["Youthful", "Upbeat"]); // remove
            this.addVoice('Alloy', 'en-US', 'ms', '234', '1', true, false, false, false, ["Warm", "Mature"]); // remove
            this.addVoice('Roger', 'en-US', 'ms', '190', '1', true);
            this.addVoice('Brian', 'en-US', 'ms', '187', '1', true, false, false, true, ["Cheerful", "Versatile"]); // remove


            // en-US AI
            this.addVoice('Jane', 'en-US', 'ms', '66', '1');
            this.addVoice('Tony', 'en-US', 'ms', '73', '1');
            this.addVoice('Sara', 'en-US', 'ms', '63', '1');
            this.addVoice('Eric', 'en-US', 'ms', '62', '1');
            this.addVoice('Jason', 'en-US', 'ms', '72', '1');
            this.addVoice('Ana (Child)', 'en-US', 'ms', '8', '1');
            this.addVoice('Matthew', 'en-US', 'aws', '0', '1');
            this.addVoice('Salli', 'en-US', 'aws', '3', '1');
            this.addVoice('Liam', 'en-US', 'ms', '7', '1');

            // en-GB
            this.addVoice('Ada', 'en-GB', 'ms', '217', '1', true, false, true, false, ["Calm", "Soft"]);
            this.addVoice('Ollie', 'en-GB', 'ms', '218', '1', true, false, true, false, ["Calm", "Narrator"]);

            // en-GB AI
            this.addVoice('Sonia', 'en-GB', 'ms', '9', '1');
            this.addVoice('Ryan', 'en-GB', 'ms', '12', '1');
            this.addVoice('Libby', 'en-GB', 'ms', '13', '1');
            this.addVoice('Bella', 'en-GB', 'ms', '68', '1');
            this.addVoice('Oliver', 'en-GB', 'ms', '69', '1');
            this.addVoice('Maisie (Child)', 'en-GB', 'ms', '75', '1');
            this.addVoice('Brian', 'en-GB', 'aws', '6', '1');
            this.addVoice('Emma', 'en-GB', 'aws', '7', '1');
            this.addVoice('Abbi', 'en-GB', 'ms', '105', '1');
            this.addVoice('Thomas', 'en-GB', 'ms', '112', '1');
            this.addVoice('Ethan', 'en-GB', 'ms', '116', '1');
            this.addVoice('Hollie', 'en-GB', 'ms', '119', '1');
            this.addVoice('Noah', 'en-GB', 'ms', '191', '1');
            this.addVoice('Elliot', 'en-GB', 'ms', '192', '1');

            // en-GB LLM
            this.addVoice('Alessio', 'en-GB', 'ms', '223', '1', true, false, false, true, ["Expressive", "Upbeat"]);
            this.addVoice('Amanda', 'en-GB', 'ms', '236', '1', true, false, false, true, ["Bright", "Youthful"]);
            this.addVoice('Arabella', 'en-GB', 'ms', '219', '1', true, false, false, true, ["Mature", "Confident"]);
            this.addVoice('Brandon', 'en-GB', 'ms', '64', '1', true, false, false, true, ["Soft", "Warm"]);
            this.addVoice('Brian', 'en-GB', 'ms', '187', '1', true, false, false, true, ["Cheerful", "Versatile"]);
            this.addVoice('Evelyn', 'en-GB', 'ms', '211', '1', true, false, false, true, ["Soft", "Emotional"]);
            this.addVoice('Florian', 'en-GB', 'ms', '141', '1', true, false, false, true, ["Warm", "Cheerul"]);
            this.addVoice('Giuseppe', 'en-GB', 'ms', '148', '1', true, false, false, true, ["Upbeat", "Expressive"]);
            this.addVoice('Isabella', 'en-GB', 'ms', '243', '1', true, false, false, true, ["Soft", "Sincere"]);
            this.addVoice('Isidora', 'en-GB', 'ms', '220', '1', true, false, false, true, ["Warm", "Formal"]);
            this.addVoice('Lucien', 'en-GB', 'ms', '222', '1', true, false, false, true, ["Warm", "Confident"]);
            this.addVoice('Macerio', 'en-GB', 'ms', '227', '1', true, false, false, false, ["Clear", "Confident"]);
            this.addVoice('Marcello', 'en-GB', 'ms', '224', '1', true, false, false, false, ["Mature", "Warm"]);
            this.addVoice('Remy', 'en-GB', 'ms', '138', '1', true, false, false, false, ["Bright", "Cheerful"]);
            this.addVoice('Seraphina', 'en-GB', 'ms', '140', '1', true, false, false, false, ["Casual", "Charming"]);
            this.addVoice('Thalita', 'en-GB', 'ms', '228', '1', true, false, false, false, ["Sincere", "Warm"]);
            this.addVoice('Vivienne', 'en-GB', 'ms', '139', '1', true, false, false, false, ["Warm", "Casual"]);
            this.addVoice('Xiaochen', 'en-GB', 'ms', '245', '1', true, false, false, false, ["Formal", "Professional"]);
            this.addVoice('Ximena', 'en-GB', 'ms', '241', '1', true, false, false, false, ["Profressional", "Upbeat"]);

            // French LLM
            this.addVoice('Lucien', 'fr-FR', 'ms', '222', '1', true, false, false, false, ["Warm", "Confident"]);
            this.addVoice('Remy', 'fr-FR', 'ms', '138', '1', true, false, false, false, ["Bright", "Cheerful"]);
            this.addVoice('Vivienne', 'fr-FR', 'ms', '139', '1', true, false, false, false, ["Warm", "Casual"]);

            // French AI
            this.addVoice('Celeste', 'fr-FR', 'ms', '153', '1');
            this.addVoice('Jerome', 'fr-FR', 'ms', '154', '1');
            this.addVoice('Maurice', 'fr-FR', 'ms', '155', '1');
            this.addVoice('Henri', 'fr-FR', 'ms', '26', '1');
            this.addVoice('Denise', 'fr-FR', 'ms', '27', '1');
            this.addVoice('Mathieu', 'fr-FR', 'aws', '37', '1'); // French
            this.addVoice('Céline', 'fr-FR', 'aws', '38', '1');
            this.addVoice('Eloise (Child)', 'fr-FR', 'ms', '70', '1');
            this.addVoice('Brigitte', 'fr-FR', 'ms', '71', '1');
            this.addVoice('Charline', 'fr-BE', 'ms', '126', '1');
            this.addVoice('Gerard', 'fr-BE', 'ms', '127', '1');
            this.addVoice('Antoine', 'fr-CA', 'ms', '23', '1'); // Canadian French
            this.addVoice('Sylvie', 'fr-CA', 'ms', '24', '1'); // Canadian French
            this.addVoice('Jean', 'fr-CA', 'ms', '25', '1'); // Canadian French
            this.addVoice('Chantal', 'fr-CA', 'aws', '39', '1'); // Canadian French
            this.addVoice('Ariane', 'fr-CH', 'ms', '128', '1');
            this.addVoice('Fabrice', 'fr-CH', 'ms', '129', '1');

            // German LLM
            this.addVoice('Seraphina', 'de-DE', 'ms', '140', '1', true, false, false, false, ["Casual", "Charming"]);
            this.addVoice('Florian', 'de-DE', 'ms', '141', '1', true, false, false, false, ["Warm", "Cheerul"]);

            // German AI
            this.addVoice('Elke', 'de-DE', 'ms', '150', '1');
            this.addVoice('Christoph', 'de-DE', 'ms', '151', '1');
            this.addVoice('Bernd', 'de-DE', 'ms', '152', '1');
            this.addVoice('Conrad', 'de-DE', 'ms', '28', '1');
            this.addVoice('Katja', 'de-DE', 'ms', '29', '1');
            this.addVoice('Hans', 'de-DE', 'aws', '46', '1');
            this.addVoice('Vicki', 'de-DE', 'aws', '44', '1');
            this.addVoice('Marlene', 'de-DE', 'aws', '45', '1');
            this.addVoice('Ingrid', 'de-AT', 'ms', '130', '1');
            this.addVoice('Jonas', 'de-AT', 'ms', '131', '1');
            this.addVoice('Leni', 'de-CH', 'ms', '132', '1');
            this.addVoice('Jan', 'de-CH', 'ms', '133', '1');

            // Italian LLM
            this.addVoice('Alessio', 'it-IT', 'ms', '223', '1', true, false, false, true, ["Expressive", "Upbeat"]);
            this.addVoice('Marcello', 'it-IT', 'ms', '224', '1', true, false, false, true, ["Mature", "Warm"]);
            this.addVoice('Giuseppe', 'it-IT', 'ms', '148', '1', true, false, false, true, ["Upbeat", "Expressive"]);
            this.addVoice('Isabella', 'it-IT', 'ms', '243', '1', true, false, false, true, ["Soft", "Sincere"]);

            // Italian AI
            this.addVoice('Pierina', 'it-IT', 'ms', '146', '1');
            this.addVoice('Lisandro', 'it-IT', 'ms', '147', '1');
            this.addVoice('Irma', 'it-IT', 'ms', '149', '1');
            this.addVoice('Diego', 'it-IT', 'ms', '30', '1');
            this.addVoice('Elsa', 'it-IT', 'ms', '32', '1');
            this.addVoice('Giorgio', 'it-IT', 'aws', '33', '1'); // Italian
            this.addVoice('Carla', 'it-IT', 'aws', '34', '1');
            this.addVoice('Rinaldo', 'it-IT', 'ms', '103', '1');
            this.addVoice('Cataldo', 'it-IT', 'ms', '108', '1');
            this.addVoice('Fiamma', 'it-IT', 'ms', '113', '1');
            this.addVoice('Benigno', 'it-IT', 'ms', '110', '1');

            // Korean LLM
            this.addVoice('Hyunsu', 'ko-KR', 'ms', '226', '1', true, false, false, true, ["Soft", "Warm"]);

            // Korean AI
            this.addVoice('SunHi', 'ko-KR', 'ms', '89', '1'); // Korean
            this.addVoice('InJoon', 'ko-KR', 'ms', '90', '1'); // Korean
            this.addVoice('SoonBok', 'ko-KR', 'ms', '91', '1'); // Korean

            // Japanese LLM
            this.addVoice('Masaru', 'ja-JP', 'ms', '225', '1', true, false, false, true, ["Warm", "Conversational"]);

            // Japanese AI
            this.addVoice('Daichi', 'ja-JP', 'ms', '84', '1'); // Japanese
            this.addVoice('Mayu', 'ja-JP', 'ms', '85', '1'); // Japanese
            this.addVoice('Aoi (Child)', 'ja-JP', 'ms', '86', '1'); // Japanese
            this.addVoice('Nanami', 'ja-JP', 'ms', '87', '1'); // Japanese
            this.addVoice('Keita', 'ja-JP', 'ms', '88', '1'); // Japanese

            // Portuguese LLM
            this.addVoice('Macerio', 'pt-BR', 'ms', '227', '1', true, false, false, true, ["Clear", "Confident"]);
            this.addVoice('Thalita', 'pt-BR', 'ms', '228', '1', true, false, false, true, ["Sincere", "Warm"]);

            // Portuguese AI
            this.addVoice('Duarte', 'pt-PT', 'ms', '36', '1');
            this.addVoice('Fernanda', 'pt-PT', 'ms', '37', '1');
            this.addVoice('Raquel', 'pt-PT', 'ms', '38', '1');
            this.addVoice('Cristiano', 'pt-PT', 'aws', '20', '1');
            this.addVoice('Inês', 'pt-PT', 'aws', '19', '1'); // Portuguese
            this.addVoice('Antonio', 'pt-BR', 'ms', '39', '1');
            this.addVoice('Francisca', 'pt-BR', 'ms', '40', '1');
            this.addVoice('Ricardo', 'pt-BR', 'aws', '22', '1');
            this.addVoice('Vitória', 'pt-BR', 'aws', '21', '1'); // Brazilian Portuguese

            // Spanish LLM
            this.addVoice('Arabella', 'es-ES', 'ms', '219', '1', true, false, false, true, ["Mature", "Confident"]);
            this.addVoice('Isidora', 'es-ES', 'ms', '220', '1', true, false, false, true, ["Warm", "Formal"]);
            this.addVoice('Tristan', 'es-ES', 'ms', '221', '1', true, false, false, true, ["Authoritative", "Confident"]);

            // Spanish AI
            this.addVoice('Alvaro', 'es-ES', 'ms', '49', '1');
            this.addVoice('Elvira', 'es-ES', 'ms', '50', '1');
            this.addVoice('Enrique', 'es-CA', 'aws', '42', '1'); // Castilian Spanish
            this.addVoice('Conchita', 'es-CA', 'aws', '43', '1');
            this.addVoice('Alonso', 'es-US', 'ms', '51', '1');
            this.addVoice('Paloma', 'es-US', 'ms', '52', '1');
            this.addVoice('Miguel', 'es-US', 'aws', '41', '1');
            this.addVoice('Penélope', 'es-US', 'aws', '40', '1'); // US Spanish
            this.addVoice('Marina (Child)', 'es-MX', 'ms', '109', '1'); // Mexican Spanish
            this.addVoice('Beatriz', 'es-MX', 'ms', '111', '1');
            this.addVoice('Gerardo', 'es-MX', 'ms', '114', '1');
            this.addVoice('Carlota', 'es-MX', 'ms', '117', '1');
            this.addVoice('Pelayo', 'es-MX', 'ms', '118', '1');
            this.addVoice('Nil', 'es-ES', 'ms', '142', '1');
            this.addVoice('Triana', 'es-ES', 'ms', '143', '1');
            this.addVoice('Arnau', 'es-ES', 'ms', '144', '1');

            // Chinese LLM
            this.addVoice('Xiaochen', 'zh-CN', 'ms', '245', '1', true, false, false, true, ["Formal", "Professional"]);
            this.addVoice('Yunyi', 'zh-CN', 'ms', '229', '1', true, false, false, true, ["Expressive", "Warm"]);
            this.addVoice('Xiaoyu', 'zh-CN', 'ms', '230', '1', true, false, false, true, ["Clear", "Soft"]);
            this.addVoice('Yunfan', 'zh-CN', 'ms', '231', '1', true, false, false, true, ["Convserational", "Expressive"]);
            this.addVoice('Yunxiao', 'zh-CN', 'ms', '232', '1', true, false, false, true, ["Authoritative", "Formal"]);
            this.addVoice('Xiaoxiao', 'zh-CN', 'ms', '244', '1', true, false, false, true, ["Warm", "Soft"]);

            // Chinese AI
            this.addVoice('Yunjian', 'zh-CN', 'ms', '76', '1');
            this.addVoice('Yunze', 'zh-CN', 'ms', '78', '1');
            this.addVoice('Xiaoqiu', 'zh-CN', 'ms', '79', '1');
            this.addVoice('YunJhe', 'zh-TW', 'ms', '80', '1');
            this.addVoice('HsiaoChen', 'zh-TW', 'ms', '81', '1');
            this.addVoice('WanLung', 'zh-HK', 'ms', '82', '1');
            this.addVoice('HiuMaan', 'zh-HK', 'ms', '83', '1');

            this.addVoice('William', 'en-AU', 'ms', '16', '1');
            this.addVoice('Natasha', 'en-AU', 'ms', '17', '1');
            this.addVoice('Russell', 'en-AU', 'aws', '9', '1'); // Australian English
            this.addVoice('Nicole', 'en-AU', 'aws', '10', '1');
            this.addVoice('Annette', 'en-AU', 'ms', '101', '1');
            this.addVoice('Freya', 'en-AU', 'ms', '102', '1');
            this.addVoice('Ken', 'en-AU', 'ms', '104', '1');
            this.addVoice('Darren', 'en-AU', 'ms', '106', '1');
            this.addVoice('Kim', 'en-AU', 'ms', '107', '1');
            this.addVoice('Tim', 'en-AU', 'ms', '115', '1');
            this.addVoice('Neil', 'en-AU', 'ms', '193', '1');
            this.addVoice('Carly', 'en-AU', 'ms', '194', '1');

            this.addVoice('Neerja', 'en-IN', 'ms', '14', '1'); // Indian English
            this.addVoice('Prabhat', 'en-IN', 'ms', '15', '1'); // Indian English
            this.addVoice('Raveena', 'en-IN', 'aws', '12', '1'); // Indian English
            this.addVoice('Aditi', 'en-IN', 'aws', '13', '1');

            this.addVoice('Elimu', 'en-TZ', 'ms', '195', '1'); // English Tanzania
            this.addVoice('Imani', 'en-TZ', 'ms', '196', '1');

            this.addVoice('Molly', 'en-NZ', 'ms', '197', '1'); // English New Zealand
            this.addVoice('Mitchell', 'en-NZ', 'ms', '198', '1');

            this.addVoice('Connor', 'en-IE', 'ms', '199', '1'); // English Ireland
            this.addVoice('Emily', 'en-IE', 'ms', '200', '1');

            this.addVoice('Asilia', 'en-KE', 'ms', '201', '1'); // English Kenya
            this.addVoice('Chilemba', 'en-KE', 'ms', '202', '1');

            this.addVoice('Rosa', 'en-PH', 'ms', '203', '1'); // English Philippines
            this.addVoice('James', 'en-PH', 'ms', '204', '1');

            this.addVoice('Wayne', 'en-SG', 'ms', '205', '1'); // English Singapore
            this.addVoice('Luna', 'en-SG', 'ms', '206', '1');

            this.addVoice('Geraint', 'en-CY', 'aws', '11', '1');  // Welsh English


            this.addVoice('Colette', 'nl-NL', 'ms', '20', '1');
            this.addVoice('Maarten', 'nl-NL', 'ms', '21', '1');
            this.addVoice('Fenna', 'nl-NL', 'ms', '22', '1');
            this.addVoice('Ruben', 'nl-NL', 'aws', '27', '1'); // Dutch
            this.addVoice('Lotte', 'nl-NL', 'aws', '28', '1');

            this.addVoice('Mattias', 'sv-SE', 'ms', '53', '1'); // Swedish
            this.addVoice('Sofie', 'sv-SE', 'ms', '54', '1'); // Swedish
            this.addVoice('Hillevi', 'sv-SE', 'ms', '55', '1'); // Swedish
            this.addVoice('Astrid', 'sv-SE', 'aws', '15', '1'); // Swedish

            this.addVoice('Christel', 'da-DK', 'ms', '18', '1');
            this.addVoice('Jeppe', 'da-DK', 'ms', '19', '1');
            this.addVoice('Naja', 'da-DK', 'aws', '47', '1'); // Danish
            this.addVoice('Mads', 'da-DK', 'aws', '48', '1');

            this.addVoice('Karl', 'is-IS', 'aws', '35', '1'); // Icelandic
            this.addVoice('Dóra', 'is-IS', 'aws', '36', '1');

            this.addVoice('Finn', 'nb-NO', 'ms', '41', '1'); // Norwegian ms uses nb-NO
            this.addVoice('Pernille', 'nb-NO', 'ms', '42', '1'); // Norwegian
            this.addVoice('Iselin', 'nb-NO', 'ms', '43', '1'); // Norwegian
            this.addVoice('Liv', 'no-NO', 'aws', '29', '1'); // Norwegian

            this.addVoice('Marek', 'pl-PL', 'ms', '33', '1');
            this.addVoice('Agnieszka', 'pl-PL', 'ms', '34', '1');
            this.addVoice('Zofia', 'pl-PL', 'ms', '35', '1');
            this.addVoice('Maja', 'pl-PL', 'aws', '23', '1'); // Polish
            this.addVoice('Jan', 'pl-PL', 'aws', '24', '1');
            // this.addVoice('Jacek', 'pl-PL', 'aws', '25', '1');
            // this.addVoice('Ewa', 'pl-PL', 'aws', '26', '1');

            this.addVoice('Emil', 'ro-RO', 'ms', '44', '1');
            this.addVoice('Alina', 'ro-RO', 'ms', '45', '1');
            this.addVoice('Carmen', 'ro-RO', 'aws', '18', '1'); // Romanian

            this.addVoice('Ahmet', 'tr-TR', 'ms', '56', '1'); // Turkish
            this.addVoice('Emel', 'tr-TR', 'ms', '57', '1'); // Turkish
            this.addVoice('Filiz', 'tr-TR', 'aws', '14', '1'); // Turkish

            this.addVoice('Aled', 'cy-GB', 'ms', '58', '1'); // Welsh
            this.addVoice('Nia', 'cy-GB', 'ms', '59', '1'); // Welsh
            this.addVoice('Gwyneth', 'cy-GB', 'aws', '49', '1'); // Welsh

            this.addVoice('Rami', 'ar-LB', 'ms', '93', '12'); // Arabic
            this.addVoice('Saleh', 'ar-YE', 'ms', '94', '12'); // Arabic
            this.addVoice('Laith', 'ar-SY', 'ms', '95', '12'); // Arabic
            this.addVoice('Salma', 'ar-EG', 'ms', '96', '21'); // Arabic
            this.addVoice('Rana', 'ar-IQ', 'ms', '97', '21'); // Arabic
            this.addVoice('Iman', 'ar-LY', 'ms', '98', '21'); // Arabic

            this.addVoice('Avri', 'he-IL', 'ms', '99', '12'); // Hebrew
            this.addVoice('Hila', 'he-IL', 'ms', '100', '21'); // Hebrew

            this.addVoice('Kalina', 'bg-BG', 'ms', '156', '21'); // Bulgarian
            this.addVoice('Borislav', 'bg-BG', 'ms', '157', '21'); // Bulgarian

            this.addVoice('Athina', 'el-GR', 'ms', '158', '21'); // Greek
            this.addVoice('Nestoras', 'el-GR', 'ms', '159', '21'); // Greek

            this.addVoice('Gadis', 'id-ID', 'ms', '160', '21'); // Indonesian
            this.addVoice('Ardi', 'id-ID', 'ms', '161', '21'); // Indonesian

            this.addVoice('Yasmin', 'ms-MY', 'ms', '162', '21'); // Malay
            this.addVoice('Osman', 'ms-MY', 'ms', '163', '21'); // Malay

            this.addVoice('Premwadee', 'th-TH', 'ms', '164', '21'); // Thai
            this.addVoice('Niwat', 'th-TH', 'ms', '165', '21'); // Thai
            this.addVoice('Achara', 'th-TH', 'ms', '185', '21'); // Thai

            this.addVoice('Gul', 'ur-IN', 'ms', '166', '21'); // Urdu
            this.addVoice('Salman', 'ur-IN', 'ms', '167', '21'); // Urdu

            this.addVoice('HoaiMy', 'vi-VN', 'ms', '168', '21'); // Vietnamese
            this.addVoice('NamMinh', 'vi-VN', 'ms', '169', '21'); // Vietnamese

            this.addVoice('Orla', 'ga-IE', 'ms', '170', '21'); // Irish
            this.addVoice('Colm', 'ga-IE', 'ms', '171', '21'); // Irish

            this.addVoice('Anu', 'et-EE', 'ms', '172', '21'); // Estonian
            this.addVoice('Kert', 'et-EE', 'ms', '173', '21'); // Estonian

            this.addVoice('Joana', 'ca-ES', 'ms', '174', '21'); // Catalan
            this.addVoice('Enrique', 'ca-ES', 'ms', '175', '21'); // Catalan
            this.addVoice('Alba', 'ca-ES', 'ms', '176', '21'); // Catalan

            this.addVoice('Polina', 'uk-UA', 'ms', '177', '21'); // Ukrainian
            this.addVoice('Ostap', 'uk-UA', 'ms', '178', '21'); // Ukrainian

            this.addVoice('Eka', 'ka-GE', 'ms', '179', '21'); // Georgian
            this.addVoice('Giorgi', 'ka-GE', 'ms', '180', '21'); // Georgian

            this.addVoice('Gabrijela', 'hr-HR', 'ms', '181', '21'); // Croatian
            this.addVoice('Srecko', 'hr-HR', 'ms', '182', '21'); // Croatian

            this.addVoice('Vlasta', 'cs-CZ', 'ms', '183', '21'); // Czech
            this.addVoice('Antonin', 'cs-CZ', 'ms', '184', '21'); // Czech

            this.setFeaturedVoices();

            // voices to be removed in the future
            // en-US legacy
            this.addVoice('Jenny', 'en-US', 'ms', '122', '1', false, true);
            this.addVoice('Ryan', 'en-US', 'ms', '123', '1', false, true);
            this.addVoice('Fable', 'en-US', 'openai', '2', '1', false, true);
            this.addVoice('Onyx', 'en-US', 'openai', '3', '1', false, true);
            // this.addVoice('Nova', 'en-US', 'openai', '4', '1', true, true);
            this.addVoice('Shimmer', 'en-US', 'openai', '5', '1', false, true);
            this.addVoice('Andrew', 'en-US', 'ms', '120', '1', true, true);
            this.addVoice('Emma', 'en-US', 'ms', '11', '1', true, true);
            this.addVoice('Elizabeth', 'en-US', 'ms', '4', '1', false, true);
            this.addVoice('Guy', 'en-US', 'ms', '5', '1', false, true);
            this.addVoice('Michelle', 'en-US', 'ms', '6', '1', false, true);
            this.addVoice('Joanna', 'en-US', 'aws', '1', '1', false, true);
            this.addVoice('Joey', 'en-US', 'aws', '2', '1', false, true);
            this.addVoice('Kimberly', 'en-US', 'aws', '4', '1', false, true);
            this.addVoice('Kendra', 'en-US', 'aws', '5', '1', false, true);
            this.addVoice('Echo', 'en-US', 'openai', '1', '1', false, true);
            this.addVoice('Brandon', 'en-US', 'ms', '64', '1', true, true);
            this.addVoice('Davis', 'en-US', 'ms', '238', '1', true, true);
            this.addVoice('Nancy', 'en-US', 'ms', '237', '1', true, true);
            this.addVoice('Steffan', 'en-US', 'ms', '74', '1', true, true);

            this.addVoice('Amy', 'en-GB', 'aws', '8', '1', false, true);
            this.addVoice('Jacek', 'pl-PL', 'aws', '25', '1', false, true);
            this.addVoice('Ewa', 'pl-PL', 'aws', '26', '1', false, true);
            this.addVoice('Maxim', 'ru-RU', 'aws', '17', '1', false, true);
            this.addVoice('Tatyana', 'ru-RU', 'aws', '16', '1', false, true);
          });
      })
      .then(() => {
        console.log("voices", this.voices);
        if (this.clonedVoices.size > 0) {
          this.setCombinedVoices();
        }
        this.isVoicesSet = true;
      })
      .catch(function (err) {
        console.log('err plus-voices.service/setVoices', err);
      });;
  }

  public setFeaturedVoices() {
    // 20 LLM 
    this.addVoice('Ada', 'en-GB', 'ms', '217', '1', true, false, false, true, ["Calm", "Soft"], true);
    this.addVoice('Alloy', 'en-US', 'ms', '234', '1', true, false, false, true, ["Warm", "Mature"], true);
    this.addVoice('Alessio', 'it-IT', 'ms', '223', '1', true, false, false, true, ["Expressive", "Upbeat"], true);
    this.addVoice('Arabella', 'es-ES', 'ms', '219', '1', true, false, false, true, ["Mature", "Confident"], true);
    this.addVoice('Brian', 'en-US', 'ms', '187', '1', true, false, false, true, ["Cheerful", "Versatile"], true);
    this.addVoice('Florian', 'de-DE', 'ms', '141', '1', true, false, false, true, ["Warm", "Cheerul"], true);
    this.addVoice('Giuseppe', 'it-IT', 'ms', '148', '1', true, false, false, true, ["Upbeat", "Expressive"], true);
    this.addVoice('Nova', 'en-US', 'ms', '233', '1', true, false, false, true, ["Youthful", "Upbeat"], true);
    this.addVoice('Ollie', 'en-GB', 'ms', '218', '1', true, false, false, true, ["Calm", "Narrator"], true);
    this.addVoice('Remy', 'fr-FR', 'ms', '138', '1', true, false, false, true, ["Bright", "Cheerful"], true);
    this.addVoice('Seraphina', 'de-DE', 'ms', '140', '1', true, false, false, true, ["Casual", "Charming"], true);
    this.addVoice('Vivienne', 'fr-FR', 'ms', '139', '1', true, false, false, true, ["Warm", "Casual"], true);
    this.addVoice('Isabella', 'it-IT', 'ms', '243', '1', true, false, false, true, ["Soft", "Sincere"], true);
    this.addVoice('Masaru', 'ja-JP', 'ms', '225', '1', true, false, false, true, ["Warm", "Conversational"], true);
    this.addVoice('Marcello', 'it-IT', 'ms', '224', '1', true, false, false, true, ["Mature", "Warm"], true);
    this.addVoice('Macerio', 'pt-BR', 'ms', '227', '1', true, false, false, true, ["Clear", "Confident"], true);
    this.addVoice('Thalita', 'pt-BR', 'ms', '228', '1', true, false, false, true, ["Sincere", "Warm"], true);
    this.addVoice('Xiaochen', 'zh-CN', 'ms', '245', '1', true, false, false, true, ["Formal", "Professional"], true);
    this.addVoice('Yunyi', 'zh-CN', 'ms', '229', '1', true, false, false, true, ["Expressive", "Warm"], true);
    this.addVoice('Yunfan', 'zh-CN', 'ms', '231', '1', true, false, false, true, ["Convserational", "Expressive"], true);
  }

  public getVoices() {
    if (this.clonedVoices.size === 0) {
      console.log("getVoices1");
      return this.voices;
    }
    else {
      if (this.communityVoices.size === 0) {
        if (this.combinedVoices.size === this.clonedVoices.size) {
          this.combinedVoices = new Map([...this.voices, ...this.clonedVoices]);
        }
      } else {
        console.log("getVoices2");
        this.setCombinedVoices();
      }
      return this.combinedVoices;
    }
  }

  public setCombinedVoices() {
    const communityVoicesMap = Array.from(this.communityVoices.values())[0] || new Map();
    console.log("communityvoicesmap", communityVoicesMap)
    this.combinedVoices = new Map([...this.voices, ...this.clonedVoices, ...communityVoicesMap]);
    console.log("combinedVoices", this.combinedVoices);
  }

  public formPlusVoiceUrl(voice) {
    const urlPrefix = 'https://wwwnaturalreaderscom.s3.amazonaws.com/pw-previews-2024/';
    let voiceUrl = '';
    if (!voice || !voice.language || !voice.name)
      return '';
    // let languageName = this.voiceUtilService.getLanguageName(voice.language, false);
    // const locationAndLangName = this.voiceUtilService.getLocationAndLangName(voice.language)
    const index = Math.floor(Math.random() * 5);

    // let voiceName = !voice.name.includes('(Child)') ? voice.name : voice.name.slice(0, -8);
    let voiceName = voice.name;
    voiceName = encodeURIComponent(voiceName.normalize('NFC'));
    let urlSuffix = `${voice.language}/${voiceName}${index}.mp3`;
    voiceUrl = urlPrefix + urlSuffix;
    console.log("formPlusVoiceUrl", voiceUrl);
    return voiceUrl;
  }

  private addVoice(name: string, language: string, source: string, id: string, ready: string, isLlm: boolean = false, isLegacy: boolean = false, isHot: boolean = false, isNew: boolean = false, tags = [], isFeatured = false, noAuth: boolean = false): Promise<any> {
    return Promise.resolve()
      .then(() => {
        if (isLlm && !isLegacy) {
          let languageLocale = this.voiceUtilService.getLanguageAndLocaleForVoiceList(language);
          let key = name + ' ' + 'multi' + ' ' + 'plus' + ' ' + source + ' ' + id;
          if (this.voices.has(key) && this.voices.get(key).source === source && this.voices.get(key).id === id) {
          } else {
            this.voices.set(key, new PlusVoice(id, false, true, 0, 0, 'none', '', [], tags, '', '', key, name, language, 'Multi-Lingual', languageLocale.localeName, languageLocale.displayLocale, source, id, ready, noAuth, isLlm, isLegacy, isHot, isNew, this.voiceUtilService.getIcon('multi', name)));
          }
        }
        if (isFeatured) {
          let languages = Array.from(Object.values(this.voiceUtilService.languageNameToCodeMapping));
          for (let i = 0; i < languages.length; i++) {
            try {
              // add the voice to each language
              if (languages[i] === 'en-US' || languages[i] === 'en-GB' || languages[i] === 'multi') {
                // don't add to en-US and en-GB
                continue;
              }
              let languageLocale = this.voiceUtilService.getLanguageAndLocaleForVoiceList(languages[i]);
              let key = name + ' ' + languages[i] + ' ' + 'plus' + ' ' + source + ' ' + id;
              this.voices.set(key, new PlusVoice(id, false, true, 0, 0, 'none', '', [], tags, '', '', key, name, languages[i], languageLocale.languageName, languageLocale.localeName, languageLocale.displayLocale, source, id, ready, noAuth, isLlm, isLegacy, isHot, isNew, this.voiceUtilService.getIcon('multi', name)));
            } catch (err) {
              console.log('err add featured voice to a lang', languages[i], err);
            }
          }
        } else {
          let languageLocale = this.voiceUtilService.getLanguageAndLocaleForVoiceList(language);
          let key = name + ' ' + language + ' ' + 'plus' + ' ' + source + ' ' + id;
          if (this.voices.has(key) && this.voices.get(key).source === source && this.voices.get(key).id === id) {
            // don't add the voice if it already exists and from the same provider/source and id
            return;
          }
          let iconPath = '';
          if (isLlm) {
            iconPath = this.voiceUtilService.getIcon('multi', name);
          } else {
            iconPath = this.voiceUtilService.getIcon(language, name);
          }
          this.voices.set(key, new PlusVoice(id, false, true, 0, 0, 'none', '', [], tags, '', '', key, name, language, languageLocale.languageName, languageLocale.localeName, languageLocale.displayLocale, source, id, ready, noAuth, isLlm, isLegacy, isHot, isNew, iconPath));
        }
      })
      .catch(function (err) {
        console.log('err plus-voices.service/addVoice', err);
      });
  }

  public getClonedVoice(key) {
    return this.clonedVoices.get(key);
  }

}
